// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZMXK","name":"styles_name__3NKcP","phone":"styles_phone__3LgRh"};